export enum AdminRepositoriesParams {
  RepositoryId = 'repositoryId',
  CourtUploaderId = 'courtUploaderId',
}
